module.exports = __webpack_public_path__ + "media/svg-new/feedback-0737da69.svg";